import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/MultipleFileUpload/multiple-file-upload';
import { css } from '@patternfly/react-styles';
export const MultipleFileUploadTitleTextSeparator = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("div", Object.assign({ className: css(styles.multipleFileUploadTitleTextSeparator, className) }, props), children));
};
MultipleFileUploadTitleTextSeparator.displayName = 'MultipleFileUploadTitleTextSeparator';
//# sourceMappingURL=MultipleFileUploadTitleTextSeparator.js.map